import * as CommonUx from '@abb/common-ux';
import * as React from 'react';
import { connect } from 'react-redux';
import {} from 'react-router';
import { withRouter } from 'react-router-dom';
import { IConnectedComponent } from 'reducers';

export interface IThankYouProps {
  requestId: string;
  emailAddress: string;
}

class ThankYouComponent extends React.Component<IConnectedComponent & IThankYouProps, {}> {

  constructor(props: any) {
    super(props);        
  }

  handleRouteChange = () => {
    const path = '/';
    this.props.history.push(path);
  }

  render() {
    const requestId = this.props.requestId;
    const emailAddress = this.props.emailAddress;
    const img = 'Warehouse_Spareparts.jpg';

    //Additional Images for Marketing
    const abbCareImg = 'abbCare.jpg';

    return (      
      <div>
        <div className='row'>
          <div className='col-sm-12'>
            <CommonUx.Cursor cursorSize={1} style={{ marginLeft: 2, marginTop: 5 }}>
              Thank you!
            </CommonUx.Cursor>
          </div>          
        </div>
        <div className='row'>
          <div className='col-sm-6'>
            <h2>Request ID: {requestId}</h2>
            <p>Thank you for your interest in the mySpareParts Analyzer Report. Use the request number for reference when speaking with an ABB Parts Specialist.</p>
            <br/>
            <p>Please allow up to 48 hours for one of our ABB Parts Specialists to review your parts list. Check your email at <a href={`mailto:${emailAddress}`}>{emailAddress}</a> in the next couple of days to receive your link to a report assessing your matched ABB parts inventory.</p>
            <br/>
            <ul>
              <li>Lifecycle Phase</li>
              <li>Overall Risk Analysis</li>
              <li>Sourcing Concerns</li>
              <li>Repair Risk</li>
              <li>Replacement Risk</li>
            </ul>
            <br/>
            <CommonUx.Button buttonType='primary' buttonSize='default' onClick={this.handleRouteChange}>Return to Start</CommonUx.Button>
            <br/>
            <br/>
            <h3>Additional ABB Offerings</h3>
            <div className='row'>
              <div className='col-sm-4' style={{marginTop: '7px'}} onClick={this.navigateToLink('https://new.abb.com/process-automation/process-automation-service/service-agreements')}>
                <div className='col-sm-12 lightBorderAndBG'>
                  <img src={abbCareImg} className='cardImageLength' alt='ABB Care'/>
                  <div className='textPaddingWithImage'>
                    <h4><b>ABB Care</b></h4> 
                    <p>
                      Get long-term support to ensure long equipment life and 
                      continous process operation.
                    </p> 
                  </div>
                </div>
              </div>
              <div className='col-sm-4' style={{marginTop: '7px'}}>
                <div className='col-sm-12 lightBorderAndBG'>
                  <video className='cardImageLength' controls={true}>
                    <source src='./mspIntroduction.mp4' type='video/mp4'/>
                  </video>                  
                  <div className='textPadding'>
                    <h4><b>mySpareparts</b></h4> 
                    <p>
                    Demonstration of the mySpareParts application on myABB, its components Score and Analyzer, as well as the Recommended Parts and Gap Analysis reports.
                    </p> 
                  </div>
                </div>
              </div>
              <div className='col-sm-4' style={{marginTop: '7px'}}>
                <div className='col-sm-12 lightBorderAndBG'>
                  <video className='cardImageLength' controls={true}>
                    <source src='./myABBBusinessPortal.mp4' type='video/mp4'/>
                  </video>
                  <div className='textPadding'>
                    <h4><b>Business Online</b></h4> 
                    <p>
                      Business Online is a web front end application collaborating with many ABB businesses
                      to streamline their information, quotation and ordering process online towards customers as well 
                      as internally.
                    </p> 
                  </div>
                </div>
              </div>
            </div>
            <br/>
          </div>
          <div className='col-sm-6'>
            <img src={img} width='100%' height='680px' />
          </div>          
        </div>

      </div>
    );
  }

  navigateToLink = (pathName: string) => (e: React.MouseEvent<HTMLDivElement>) => {
    window.open(pathName, '_blank');
  }
}

export const ThankYou = withRouter(connect(mapStateToProps)(ThankYouComponent) as any);

function mapStateToProps(store: any) {
  return {
    requestId: store.requestInfoState.requestId,
    emailAddress: store.requestInfoState.emailAddress
  };
}
